import React from 'react';
import { useParams } from 'react-router-dom';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';

import { StickyButtons, UiKit } from 'components';
import { useProductSkuConfig } from '../../context';

export default function FooterActions() {
  const {
    errors,
    formData,
    initialData,
    isEditMode,
    isProcessing,
    onSave
  } = useProductSkuConfig();
  const { id } = useParams();

  const buttonText = isEditMode
    ? 'Save Changes'
    : 'Create Return Window Exception';

  const hasErrors = !_isEmpty(errors);
  const isButtonDisabled = hasErrors || _isEqual(formData, initialData);

  return (
    <StickyButtons
      alwaysEdit
      isEditMode={isEditMode}
      routeFragementToDiscardOnCancel={`/${id}`}
      data={formData}
      initialData={initialData}
      isProcessing={isProcessing}
      isCancelDisabled={isProcessing}
      confirmBtnText="Don't exit"
    >
      <UiKit.Button
        size="lg"
        onClick={() => onSave()}
        disabled={isButtonDisabled}
        processing={isProcessing}
      >
        {buttonText}
      </UiKit.Button>
    </StickyButtons>
  );
}
